import { Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ICRMQuestionData, QuestionsComponent } from '../../components/form-fields/questions/questions.component';
import { ActionConfigAbstract } from '../../services/actions/abstracts/action-config.abstract';
import { FieldModel } from '../../services/actions/models/field.model';
import { IDataService } from '../../services/data/data-service.interface';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';

export class QuestionActionConfig extends ActionConfigAbstract {
  protected readonly key: string = 'AffiliateCrm\\Answer\\CreateEditAnswer';
  protected readonly repository: string = 'Eloquent\\AffiliateAnswerRepository';
  protected readonly title: string = $localize`:@@common.answer_to_question:Answer to Question`;
  protected readonly description: string = '';
  protected readonly fields: FieldModel[] = [
    new FieldModel('', 'answer', QuestionsComponent, new UntypedFormControl([]), {
      data: this.data,
    }),
  ];

  constructor(
    @Inject('IDataService') dataService: IDataService,
    @Inject('RbacServiceInterface') rbacService: RbacServiceInterface,
    public data: ICRMQuestionData[]
  ) {
    super(dataService, rbacService);
  }
}
